module.exports = __webpack_public_path__ + "static/img/icon-external-link.1700a74.png";